import axios from './axios';

export default {
  list() {
    return axios.get('/products');
  },
  fetchTiroirOptiques() {
    return axios.get('/tiroir_optiques/for_unitrunk');
  },
};
